import React from "react";
import "./styles/AboutUsPage.css";

const AboutUs: React.FC = () => {
  return (
    <div className='about-page website-page'>
      <section className='about-hero website-page-hero text-center'>
        <div className='container'>
          <p className='website-page-kicker mb-2'>About Dialin24</p>
          <h2 className='website-page-title mb-3'>
            Built on trust, practical execution, and lasting quality.
          </h2>
          <p className='website-page-subtitle mb-0'>
            We deliver construction and maintenance solutions with structured
            planning, dependable teams, and clear communication at every stage.
          </p>
        </div>
      </section>

      <section className='container website-page-content'>
        <div className='row g-4'>
          <div className='col-lg-6'>
            <div className='about-info-card h-100'>
              <h5 className='fw-bold mb-3'>Our Mission</h5>
              <p>
                We deliver construction services with practical planning,
                dependable execution, and strict quality control while keeping
                transparency with every client.
              </p>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='about-info-card h-100'>
              <h5 className='fw-bold mb-3'>Our Vision</h5>
              <p>
                To be a trusted construction brand known for timely delivery,
                structural excellence, and long-term client satisfaction.
              </p>
            </div>
          </div>
        </div>
        <div className='about-leadership-section mt-5'>
          <div className='row align-items-center g-4'>
            <div className='col-lg-3'>
              <div className='about-leadership-profile-card'>
                <div className='about-leadership-image-wrap'>
                  <div className='about-leadership-avatar'>
                    <i className='bi bi-person-fill' />
                  </div>
                </div>
                <div className='about-leadership-profile-copy text-center'>
                  <h4 className='about-leadership-name mb-1'>Shrawan Kumar</h4>
                  <p className='about-leadership-role mb-2 small'>
                    CEO & Managing Director
                  </p>
                  <div className='about-leadership-meta d-flex flex-wrap justify-content-center gap-1'>
                    <span className='badge bg-light text-dark'>Execution</span>
                    <span className='badge bg-light text-dark'>Trust</span>
                    <span className='badge bg-light text-dark'>Ownership</span>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-lg-9'>
              <span className='website-section-kicker'>Leadership Message</span>
              <h4 className='fw-bold mb-3'>
                Leadership rooted in accountability and practical delivery.
              </h4>
              <p className='mb-2'>
                <strong>Shrawan Kumar</strong> leads Dialin24 with a field-first
                approach that combines disciplined planning, clear
                communication, and reliable execution.
              </p>
              <p className='mb-2'>
                At Dialin24, we believe every project should be guided by trust,
                technical discipline, and clear accountability. Our focus is not
                only to complete work on time, but to deliver outcomes that
                clients can rely on for the long term.
              </p>
              <p>
                We continue to strengthen our planning, execution standards, and
                service response so every residential and commercial assignment
                reflects professionalism, quality workmanship, and transparent
                communication.
              </p>
              <div className='about-leadership-note mt-3'>
                <i className='bi bi-quote me-2'></i>
                We build lasting client relationships by delivering dependable
                work, practical solutions, and visible project ownership.
              </div>
            </div>
          </div>
        </div>
        <div className='about-story-section website-glass-card mt-4'>
          <div className='row align-items-center g-4'>
            <div className='col-lg-6 order-lg-2'>
              <img
                src='/images/IMG-20251110-WA0006.jpg.jpeg'
                alt='Dialin24 team'
                className='img-fluid rounded-4 shadow about-team-image'
              />
            </div>
            <div className='col-lg-6 order-lg-1'>
              <span className='website-section-kicker'>Our Experience</span>
              <h4 className='fw-bold mb-3'>
                A field-first team for residential, commercial, and support
                work.
              </h4>
              <p>
                With strong field experience and skilled professionals, we
                handle residential and commercial projects with the right mix of
                planning, technology, and craftsmanship.
              </p>
              <div className='row g-3 mt-2'>
                <div className='col-sm-6'>
                  <div className='about-stat-card'>
                    <h4>500+</h4>
                    <p className='mb-0'>Projects Completed</p>
                  </div>
                </div>
                <div className='col-sm-6'>
                  <div className='about-stat-card'>
                    <h4>20+</h4>
                    <p className='mb-0'>Years of Experience</p>
                  </div>
                </div>
                <div className='col-sm-6'>
                  <div className='about-stat-card'>
                    <h4>300+</h4>
                    <p className='mb-0'>Happy Clients</p>
                  </div>
                </div>
                <div className='col-sm-6'>
                  <div className='about-stat-card'>
                    <h4>98%</h4>
                    <p className='mb-0'>Client Satisfaction</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='website-section mt-4'>
          <div className='website-section-header website-section-header-about text-center'>
            <span className='website-section-kicker'>Why Dialin24</span>
            <h3 className='fw-bold mb-0'>
              The operating standards clients rely on.
            </h3>
          </div>
        </div>
        <div className='row g-4'>
          <div className='col-md-4'>
            <div className='about-info-card h-100 text-center'>
              <i className='bi bi-tools about-icon'></i>
              <h5 className='mt-3'>Quality Workmanship</h5>
              <p className='mb-0'>
                Top-grade materials and trained teams ensure every structure is
                built to last.
              </p>
            </div>
          </div>
          <div className='col-md-4'>
            <div className='about-info-card h-100 text-center'>
              <i className='bi bi-clock-history about-icon'></i>
              <h5 className='mt-3'>Timely Delivery</h5>
              <p className='mb-0'>
                Project milestones are tracked closely to keep delivery on
                schedule.
              </p>
            </div>
          </div>
          <div className='col-md-4'>
            <div className='about-info-card h-100 text-center'>
              <i className='bi bi-people about-icon'></i>
              <h5 className='mt-3'>Client Centric</h5>
              <p className='mb-0'>
                We align design and execution with your goals, budget, and
                timeline.
              </p>
            </div>
          </div>
          <div className='col-md-4'>
            <div className='about-info-card h-100 text-center'>
              <i className='bi bi-pencil-square about-icon'></i>
              <h5 className='mt-3'>Dedicated Planning</h5>
              <p className='mb-0'>
                Clear scope definition, milestone alignment, and execution
                sequencing before work begins.
              </p>
            </div>
          </div>
          <div className='col-md-4'>
            <div className='about-info-card h-100 text-center'>
              <i className='bi bi-check-circle about-icon'></i>
              <h5 className='mt-3'>Quality Checks</h5>
              <p className='mb-0'>
                Structured site monitoring, material verification, and progress
                review at each stage.
              </p>
            </div>
          </div>
          <div className='col-md-4'>
            <div className='about-info-card h-100 text-center'>
              <i className='bi bi-chat-dots about-icon'></i>
              <h5 className='mt-3'>Responsive Support</h5>
              <p className='mb-0'>
                Fast communication for updates, changes, and post-completion
                service requirements.
              </p>
            </div>
          </div>
        </div>

        {/* <div className='row g-3 mt-4'>
          <div className='col-md-4'>
            <div className='website-metric-card'>
              <h4>Dedicated Planning</h4>
              <p>
                Clear scope definition, milestone alignment, and execution
                sequencing before work begins.
              </p>
            </div>
          </div>
          <div className='col-md-4'>
            <div className='website-metric-card'>
              <h4>Quality Checks</h4>
              <p>
                Structured site monitoring, material verification, and progress
                review at each stage.
              </p>
            </div>
          </div>
          <div className='col-md-4'>
            <div className='website-metric-card'>
              <h4>Responsive Support</h4>
              <p>
                Fast communication for updates, changes, and post-completion
                service requirements.
              </p>
            </div>
          </div>
        </div> */}

        <div className='row g-4 mt-5'></div>
      </section>
    </div>
  );
};

export default AboutUs;
